import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MailSenderService {
  constructor() {}

  sendMail(newRequest: any): Observable<any> {
    return of(true);
  }
}
